import { createContext } from 'react';

import { type IVendorsContext, VendorPageStep } from 'src/pages/VendorsPage/VendorsPage.context.types';

export const VendorsContext = createContext<IVendorsContext>({
  isEditing: false,

  isMobileGuideOpened: false,

  isLastVendorStep: false,

  vendorStep: VendorPageStep.Start,
  vendorStepsInfo: [],

  vendorLeadProduct: null,
  vendorLeadProductSpecification: null,

  vendorStepGuideKey: null,

  // biome-ignore lint/suspicious/noEmptyBlockStatements: false
  onEditing: () => {},

  // biome-ignore lint/suspicious/noEmptyBlockStatements: false
  toggleMobileGuideOpened: () => {},

  // biome-ignore lint/suspicious/noEmptyBlockStatements: false
  goNextStep: () => {},
  // biome-ignore lint/suspicious/noEmptyBlockStatements: false
  goBack: () => {},

  // biome-ignore lint/suspicious/noEmptyBlockStatements: false
  setLastVendorStep: () => {},

  // biome-ignore lint/suspicious/noEmptyBlockStatements: false
  setVendorStep: () => {},
  // biome-ignore lint/suspicious/noEmptyBlockStatements: false
  setVendorStepGuideKey: () => {},

  // biome-ignore lint/suspicious/noEmptyBlockStatements: false
  updateVendorLeadProduct: () => {},
});
